const TestimonialBox = (props) => {
    return (
      <div className="testimonial-box">
        <div className="user-profile">
          <img
            src={require('../assets/quote-icon.png')}
            alt="User Profile"
          />
        </div>
        <p>
          {props.reviewDesc}
        </p>
        <h5>{props.userName}</h5>
      </div>
    );
};

export default TestimonialBox;